"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaFuncText = exports.setJSchemaContext = exports.setContextReplacer = exports.getContextReplacer = exports.globalContext = void 0;
exports.globalContext = 'this.';
/**
 * ustawia funkcje zamiany kontekstu this w funkcjach
 */
function getContextReplacer(ctx) {
    if (ctx === void 0) { ctx = exports.globalContext; }
    if (ctx) {
        var gce = ctx.replace('.', '\\.');
        var rx1_1 = new RegExp(gce + '\\$methods', 'gm');
        var rx2_1 = new RegExp(gce + '\\$root', 'gm');
        var rx3_1 = new RegExp(gce + '\\$parent', 'gm');
        // let rx4 = new RegExp(gce + "\\$parent2", "gm");
        //let rx5 = new RegExp(gce + "\\$parent3", "gm");
        var rx6_1 = new RegExp(gce + '\\$obj', 'gm');
        var rx7_1 = new RegExp(gce + '\\$external', 'gm');
        var rx8_1 = new RegExp(gce + '\\$value', 'gm');
        var rx9_1 = new RegExp(gce + '\\$event', 'gm');
        return function (s) {
            return s
                .replace(rx1_1, '$methods')
                .replace(rx2_1, '$root')
                .replace(rx3_1, '$parent')
                //.replace(rx1, "$parent2")
                //.replace(rx1, "$parent3")
                .replace(rx6_1, '$obj')
                .replace(rx7_1, '$external')
                .replace(rx8_1, '$value')
                .replace(rx9_1, 'event');
        };
    }
    else {
        return function (s) { return s; };
    }
}
exports.getContextReplacer = getContextReplacer;
function setContextReplacer() {
    contextReplacer = getContextReplacer(exports.globalContext);
}
exports.setContextReplacer = setContextReplacer;
var contextReplacer = function (s) { return s; };
setContextReplacer();
// _this. + this.  dla es5
var repl1 = getContextReplacer('_this.');
var repl2 = getContextReplacer('this.');
contextReplacer = function (s) {
    return repl2(repl1(s));
};
function setJSchemaContext(func) {
    var s = func.toString();
    var p = s.indexOf('=>');
    if (p > -1) {
        s = s.substring(p + 2);
    }
    else {
        p = s.indexOf('{');
        var p2 = s.lastIndexOf('}');
        s = s.substring(p + 1, p2).replace('return ', '');
    }
    s = s.trim().replace(';', '');
    p = s.indexOf('$');
    if (p > -1) {
        s = s.substring(0, p);
    }
    exports.globalContext = s;
    setContextReplacer();
    return exports.globalContext;
    // s = s.replace('$methods', '').replace(';', '');
}
exports.setJSchemaContext = setJSchemaContext;
/**
 * zamiana funkcji w schemacie na tekst
 * @param s funkcja
 * @returns
 */
function schemaFuncText(
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
funcText, options) {
    if (options === void 0) { options = {}; }
    if (typeof funcText !== 'string') {
        funcText = funcText.toString();
    }
    var isArrowFunc = false;
    var s = funcText;
    if (s.startsWith('() => ')) {
        s = s.substring(6);
        isArrowFunc = true;
    }
    else if (s.startsWith('()=>')) {
        s = s.substring(4);
        isArrowFunc = true;
    }
    var p1 = s.indexOf('{');
    var p2 = s.lastIndexOf('}');
    if (p1 > -1 && p2 > p1) {
        s = s.substring(p1 + 1, p2);
        // isArrowFunc = false;
    }
    if (!options.contextFromArg) {
        if (exports.globalContext) {
            s = contextReplacer(s);
        }
    }
    // wywalenie ?.
    // s = s.replace(/\?\./, ".");
    // $parent?
    s = s.replace(/\$parent\?\./, '$parent.');
    /*
      if (!isArrowFunc) {
          s = s.replace('return ', '$result = ')
      } else {
          s = "$result = " + s;
      }
      */
    var codeLines = s
        .split('\n')
        .map(function (x) { return x.trim(); })
        .filter(function (x) { return x.length > 0; });
    if (options.removeDebugger) {
        codeLines = codeLines.filter(function (x) { return x !== 'debogger' && x !== 'debugger;'; });
    }
    if (codeLines.length === 1 && !options.skipRemoveReturn /*&& codeLines[0].startsWith('$result = ')*/) {
        // let codeLine = codeLines[0].substring(10);
        var codeLine = codeLines[0];
        if (isArrowFunc)
            return codeLine;
        //if (codeLine.startsWith('return')) {
        //(!(/(return[\s\"\!\'\(\;]|return$)/).test(stext))
        // eslint-disable-next-line no-useless-escape
        var returnPos = codeLine.search(/(return[\s\"\!\'\(\;]|return$)/);
        if (returnPos == 0) {
            codeLine = codeLine.substring(6).trimStart();
            while (codeLine.endsWith(';')) {
                codeLine = codeLine.substring(0, codeLine.length - 1);
            }
            if (codeLine !== 'void 0' && codeLine !== 'undefined') {
                return codeLine;
            }
            return undefined;
        }
    }
    return codeLines;
}
exports.schemaFuncText = schemaFuncText;
//# sourceMappingURL=schemaFuncText.js.map